import {
  DateFormat,
  useUserLocaleDateFormatting,
} from "@src/Hooks/useUserLocaleDateFormatting"
import { DateInfo } from "@src/Portal/Dashboard/TrainingCard/styles"
import { IComplianceDashboardData } from "@src/types"
import * as React from "react"

import { Description, InfoMain, InfoName, InfoNumber } from "../styles"

export const FilledStateCard: React.FC<IComplianceDashboardData> = ({
  active,
  inactive,
  draft,
  lastUpdated,
}) => {
  const { formatDate } = useUserLocaleDateFormatting()

  return (
    <>
      <InfoMain>
        <InfoName>
          <InfoNumber>{draft}</InfoNumber>
          <Description>
            Draft
            <br />
            {draft === 1 ? "Policy" : "Policies"}
          </Description>
        </InfoName>
        <hr />
        <InfoName>
          <InfoNumber>{inactive}</InfoNumber>
          <Description>
            {" "}
            Inactive
            <br />
            {inactive === 1 ? "Policy" : "Policies"}
          </Description>
        </InfoName>
        <hr />
        <InfoName>
          <InfoNumber>{active}</InfoNumber>
          <Description>
            {" "}
            {active === 1 ? "Policy" : "Policies"}
            <br />
            in Effect
          </Description>
        </InfoName>
      </InfoMain>
      {lastUpdated ? (
        <DateInfo>
          Updated {formatDate(new Date(lastUpdated), DateFormat.Date)}
        </DateInfo>
      ) : null}
    </>
  )
}
